import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { toast } from 'sonner';
import api from '@/lib/api';
import { errMsg } from './salaryApi';

export const ReportIssueDialog = ({ item, onClose, onDone }) => {
  const [type, setType] = useState('not_received');
  const [reason, setReason] = useState('');
  useEffect(() => { setType('not_received'); setReason(''); }, [item]);

  const submit = async () => {
    try {
      await api.post(`/me/payment-confirmations/${item.kind}/${item.id}/report`, { issue_type: type, reason });
      toast.success('Reported to HR — this payment stays unconfirmed');
      onDone?.();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="report-issue-dialog">
        <DialogHeader><DialogTitle>Report a problem with {item?.reference}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs">Problem</Label>
            <Select value={type} onValueChange={setType}>
              <SelectTrigger data-testid="report-issue-type"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="not_received">I did not receive it</SelectItem>
                <SelectItem value="wrong_amount">The amount is wrong</SelectItem>
                <SelectItem value="other">Other</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs">Details</Label>
            <Textarea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} data-testid="report-issue-reason" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={submit} disabled={reason.trim().length < 5} className="bg-rose-600 hover:bg-rose-700 text-white" data-testid="report-issue-submit">Send to HR</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
